import './mod/avif-webp'
import signature from 'console-signature'
import './mod/contactForm7'
import 'magnify'
import Swiper from 'swiper'
import SwiperCore, { Autoplay, EffectFade } from 'swiper/core'


;(function ($) {
    ;('use strict')

    /** Global vars defined by functions.php with 'wp_localize_script' @ script enqueue   **/
    // var global = pct_globalVars
    signature()
	var explorer = navigator.userAgent.indexOf('MSIE') > -1;
	var edge     = navigator.userAgent.indexOf('Edge') > -1;

    const winDim = () => {
        return {
            width: window.innerWidth,
            height: window.innerHeight,
        }
    }



    /*------------------------------------------------------------------------------------------------------*\

							ONLOAD modified for v 3++

	\*------------------------------------------------------------------------------------------------------*/

    window.addEventListener('load', function (event) {
        // console.log(`Script loaded @ --> ${document.location}`)
        this.document.querySelector('html').classList.add('content-loaded')
    })

    document.addEventListener("DOMContentLoaded", function (event) {
        setupSlider()
        setupMagnify()
        // const ttl = 86400000 // 1 day
        // const ttl = 60 * 1000 // 1 minute
        const ttl = 8 * 60 * 60 * 1000 // 8hs
        setupContactPopup('.pct-related-portfolio', ttl ,showContactPopup)
    });



    /**----------------------- END ONLOAD SECTION ----------------------------------------------------------*/

    const buildPopupUI = () => {
        if (document.querySelector('#contact-popup')) {
            const btMinimize = document.querySelector('#contact-popup .layer-ui .minimize')
            const btClose = document.querySelector('#contact-popup .layer-ui .close')
            const window_header = document.querySelector('#contact-popup .wind-header > div')

            btClose.addEventListener('click', (ev) => {
                closeContactPopup()
            })

            btMinimize.addEventListener('click', (ev) => {
                document.querySelector('body').classList.toggle('minimized-ctc-popup')
            })

            window_header.addEventListener('click', (ev) => {
                document.querySelector('body').classList.toggle('minimized-ctc-popup')
            })


            //minimized-ctc-popup


        }
    }


    //add class to body for showing contact popup.
    const showContactPopup = () => {
        document.querySelector('body').classList.add('show-ctc-popup')
    }

    const closeContactPopup = () => {
        document.querySelector('body').classList.remove('show-ctc-popup')
        const timeStamp = new Date()
        localStorage.setItem('ctc-pup-closed', timeStamp.getTime())
    }


    // Triger a popup form on getting scrolled to the bottom of the page...
    const setupContactPopup = (target, ttl, callback) => {
        const targetElement = document.querySelector(target)

        if (targetElement) {
            buildPopupUI()

            const observer = new IntersectionObserver((entries) => {

                if (entries[0].isIntersecting === true) {

                    const currDate = new Date()

                    if (localStorage.getItem('ctc-pup-closed')) {
                        const previousDate = localStorage.getItem('ctc-pup-closed')
                        const diffTime = currDate.getTime() - previousDate
                        // const toSeconds = 1 / (1000)

                        if (diffTime > ttl) {
                            // console.log('enseñamos popup y eliminamos contador')
                            localStorage.removeItem('ctc-pup-closed')
                            callback()
                        }
                    }
                    else {
                        // console.log('simpelmente enseñamos popup')
                        callback()
                    }

                }
            }, { threshold: [0] });

            observer.observe(targetElement);
        }
    }



    // Videos .webm plays on hover...
    if (document.querySelectorAll('video.plays-on-hover').length) {

            ;[].slice.call(document.querySelectorAll('video.plays-on-hover')).forEach(function (el) {
            const $el = $(el)


            const startPreview = () => {
                el.muted = true;
                // el.currentTime = 0;
                // el.playbackRate = 0.5;
                el.play();
            }

            const stopPreview = () => {
                // el.currentTime = 0;
                // el.playbackRate = 1;
                el.pause();
            }

            let previewTimeout = null;

            el.addEventListener("mouseenter", () => {
                startPreview();
                // previewTimeout = setTimeout(stopPreview, 4000);
            });

            el.addEventListener("mouseleave", () => {
                clearTimeout(previewTimeout);
                previewTimeout = null;
                stopPreview();
            });


        })

    }

    const setupMagnify = () => {
        if (document.querySelectorAll('.con-lupa').length) {

            [].slice.call(document.querySelectorAll('.con-lupa')).forEach(function (el) {
                const $el = $(el)
                const $img = $el.find('img')
                const src = $img.attr('src')

                // const srcset = $img.attr('srcset').split(',').at(-1).replace(/^\s+/g, '').split(' ')[0]
                // const src = $img.attr('src').split(',').at(-1).replace(/^\s+/g, '').split(' ')[0]

                // const url = new URL('https:' + src)

                // const imgFileName = url.pathname.split('.')[0]
                // const imgExtension = url.pathname.split('.')[1]

                // const largeImgSrc = url.origin + imgFileName + '@large.' + imgExtension


                $img.magnify({
                    src,
                })


            })

        }
    }

    const setupSlider = () => {

        if (document.querySelectorAll('.swiper').length) {


            ;[].slice.call(document.querySelectorAll('.swiper')).forEach(function (el) {
                const $el = $(el)
                $el.removeClass()
                $el.addClass('swiper')
                // add swiper-container class to next sibling
                const $wrapper = $el.find('> *')
                $wrapper.removeClass()
                $wrapper.addClass('swiper-wrapper')

                // add 'swiper-slide' class to every slide
                $wrapper.find('> *').addClass('swiper-slide')



                SwiperCore.use([Autoplay, EffectFade])


                const swiper = new Swiper('.swiper', {
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    centeredSlides: true,
                    // preventClicks: true,
                    grabCursor: true,
                    slideToClickedSlide: true,
                    loopAdditionalSlides: 2,
                    maxBackfaceHiddenSlides: 10,
                    preloadImages: true,
                    // watchSlidesProgress: true,
                    // shortSwipes: false,
                    // autoplay: {
                    //     delay: 2500,
                    //     pauseOnMouseEnter: false,
                    //     disableOnInteraction: true,
                    // },
                    // speed: 700,
                    // breakpoints: {
                    //     // when window width is >= 480px
                    //     480: {
                    //         slidesPerView: 2,
                    //     },
                    //     // when window width is >= 640px
                    //     700: {
                    //         slidesPerView: 4,
                    //     },
                    //     1120: {
                    //         slidesPerView: 5,
                    //     },
                    //     1550: {
                    //         slidesPerView: 6,
                    //     },
                    // },
                    // navigation: {
                    //     nextEl: '.swiper-next',
                    //     prevEl: '.swiper-prev',
                    // },
                })

                // swiper.on('slideChange', () => {
                //     console.log('slide changed');
                // });

            })

        }


    }

    /**
       //!AVIF BACKGROUND IMAGES BY CLASS SELECTOR
     *  if not AVIF capabilities, then use a .jpg instead
     * AVIF capabilities checked by avif-webp.js, adding a webp/avif class to <html> tag.
     */
    ;[].slice.call(document.querySelectorAll('[class*="pct-avif-bg-"]')).forEach(function (el) {
        var $el = $(el)
        var fileName = $el
            .attr('class')
            .match(/pct-avif-bg-(.*)+/)[0]
            .split(' ')[0]
            .split('pct-avif-bg-')[1]
        var filePath = global.mediaURL + '/' + fileName + '.' + ($('html').hasClass('avif') ? 'avif' : 'jpg')

        $el.prepend('<div class="pct-bgimg"></div>')
        var $bg = $el.find('.pct-bgimg')
        $bg.css({
            'background-image': 'url(' + filePath + ')',
            'background-size': 'cover',
            'position': 'absolute',
            'top': '0',
            'left': '0',
            'width': '100%',
            'height': '100%',
        })
    })


})(jQuery)
